import { Component, Input } from '@angular/core';
import { ClubOverviewService } from '~features/club-overview/club-overview.service';
import { ModulesType } from '~core/enum';
import { Club } from '~core/models';
import { TooltipTranslationService } from '~shared/translations';

/**
 * Component that displays the products settings in a list
 */
@Component({
  selector: 'app-club-product-access',
  templateUrl: './club-product-access.component.html',
  styleUrls: ['../../../pages/club-settings/club.component.scss']
})
export class ClubProductAccessComponent {
  @Input() public selectedClub: Club;
  readonly ModulesType = ModulesType;

  constructor(
    public clubOverviewService: ClubOverviewService,
    public tooltipTranslations: TooltipTranslationService,
  ) { }

  /**
   * Checks if there is any data inside
   */
  public containsData(): boolean {
    const tixxConnect = this.selectedClub.modules?.find(el => el.name === ModulesType.CUSTOMER)['tixxConnectApiConfiguration'];
    const campaign = this.selectedClub.modules?.find(el => el.name === ModulesType.CAMPAIGN)['cleverReachConfiguration'];

    return tixxConnect != null ? true :
      campaign != null;
  }

  public findModule(type: ModulesType) {
    const module = this.selectedClub.modules?.find(el => el.name === type);
    return module?.translatedSetup;
  }

}
